import React, { useState, useEffect } from 'react';
import CategoryHeatmapCard from "../charts/CategoryHeatmapCard";

function AccordionTableHeatmap({data, name}) {

  const [open, setOpen] = useState(false);
  const [maxItem, setMaxItem] = useState(null);

  useEffect(() => {
    if(data!=null && name!=null && data.length>0) {
      setMaxItem(data.reduce((max, item) => max.y > item.y ? max : item))
    }
  }, [data, name]);

  return (
    <tbody className="text-sm">
      <tr>
        <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
          <div className="text-left font-medium text-emerald-500">{name}</div>
        </td>
        <td className="flex justify-end pr-20 py-4 whitespace-nowrap">
          <div className="flex items-center">
            {/*<svg className="w-4 h-4 fill-current text-slate-400 shrink-0 mr-2" viewBox="0 0 16 16">
              <path d="M4.3 4.5c1.9-1.9 5.1-1.9 7 0 .7.7 1.2 1.7 1.4 2.7l2-.3c-.2-1.5-.9-2.8-1.9-3.8C10.1.4 5.7.4 2.9 3.1L.7.9 0 7.3l6.4-.7-2.1-2.1zM15.6 8.7l-6.4.7 2.1 2.1c-1.9 1.9-5.1 1.9-7 0-.7-.7-1.2-1.7-1.4-2.7l-2 .3c.2 1.5.9 2.8 1.9 3.8 1.4 1.4 3.1 2 4.9 2 1.8 0 3.6-.7 4.9-2l2.2 2.2.8-6.4z" />
            </svg>*/}
            <mark className="bg-pink-400
                   text-white rounded-full px-2.5 py-1">{maxItem!=null?(maxItem.x):''}</mark>
            <small className="pl-3">({maxItem!=null?parseFloat(maxItem.y).toFixed(1):''}% confident)</small>
          </div>
        </td>
        <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap w-px">
          <div className="flex items-center">
            <button
              className={`text-slate-400 hover:text-slate-500 ${open && 'rotate-180'}`}
              aria-expanded={open}
              onClick={() => setOpen(!open)}
              aria-controls={`description-1`} >
              <span className="sr-only">Menu</span>
              <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32">
                <path d="M16 20l-5.4-5.4 1.4-1.4 4 4 4-4 1.4 1.4z" />
              </svg>
            </button>
          </div>
        </td>
      </tr>
      <tr id={`description-1`} role="region" className={`${!open && 'hidden'}`}>
        <td colSpan="10" className="px-2 first:pl-5 last:pr-5 py-3">
          <div className="flex items-center bg-slate-50 ">
            <CategoryHeatmapCard data={data} name={name}/>
          </div>
        </td>
      </tr>
    </tbody>
  );
}

export default AccordionTableHeatmap;
